import React, { Component } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import { withTranslation } from "react-i18next"; // Import withTranslation

class OpenMap extends Component {
    state = {
        lat: 42.651313,
        lng: 23.348977,
        zoom: 15,
    };

    render() {
        const { t } = this.props; // Destructure t from props
        const position = [this.state.lat, this.state.lng];

        return (
            <Map center={position} zoom={this.state.zoom}>
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={position}>
                    <Popup>
                        {t("universityName")} {/* Translate "Университет за национално и световно стопанство" */}
                    </Popup>
                </Marker>
            </Map>
        );
    }
}

//OpenMap.propTypes = {
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

export default withTranslation()(OpenMap); // Wrap the component with withTranslation

//import React, { Component } from 'react'
//import { Map, TileLayer, Marker, Popup } from 'react-leaflet'

//export default class OpenMap extends Component {
//    state = {
//        lat: 42.651313,
//        lng: 23.348977,
//        zoom: 15,
//    }

//    render() {
//        const position = [this.state.lat, this.state.lng]
//        return (
//            <Map center={position} zoom={this.state.zoom}>
//                <TileLayer
//                    attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
//                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                />
//                <Marker position={position}>
//                    <Popup>
//                        Университет за национално и световно стопанство
//                    </Popup>
//                </Marker>
//            </Map>
//        )
//    }
//}